import React from 'react';
import { useAuth } from '../state/AuthProvider';
import Card from './Card';
import Button from './Button';
import { getUserNameFromJwt } from '../utils';
import '../assets/styles.css'
import { useChat } from '../state/ChatProvider';
import Spinner from './Spinner';
import Link from './Link';

const WelcomeBack = () => {
    const { token, logOut, silentAuthApplied } = useAuth();
    const { startChat, endChat, isChatStarting, chatEndedMessage } = useChat();

    const userName = getUserNameFromJwt(token);

    const handleLogout = async () => {
        await endChat();
        await logOut();
    }

    // Three subtitle states:
    //   - chatEndedMessage: bot ended the previous chat (existing behaviour).
    //   - silentAuthApplied: the user was just authenticated via a kanisAuthToken — they didn't
    //     "come back", they arrived fresh, so the "remembered you" framing is wrong.
    //   - default: the user has a persisted JWT from a prior session.
    const subtitle = chatEndedMessage
      ?? (silentAuthApplied
        ? 'What can I help with?'
        : `We've remembered you from a previous conversation. Let's get started.`);

    return (
        <Card>
            <div className='_kanis_card_title'>Hi {userName}</div>
            <div className='_kanis_card_subtitle'>{subtitle}</div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <Button type='primary' onClick={() => startChat()} style={{ width: '100px' }} disabled={isChatStarting}>
                    {isChatStarting ? <Spinner size='small' /> : <span>Start Chat</span>}
                </Button>
            </div>
            <Link onClick={handleLogout}>Log in with a different email</Link>
        </Card>
    );
}

export default WelcomeBack;
